import { IPermissionsContext } from "./ipermissions-context.interface";
import { BriefType, UserGroup } from "../../../../constants/types";
import { IUser } from "../../iuser.interface";

export const isDraft = (context: IPermissionsContext): boolean => context.pageStatus === "draft";

export function isPageTypeWorkOrder(context: IPermissionsContext): boolean {
  return context.pageType === BriefType.WORK_ORDER;
}

export function isPageTypeCampaignBrief(context: IPermissionsContext): boolean {
  return context.pageType === BriefType.CAMPAIGN_BRIEF;
}

export function isPageTypeExecutionBrief(context: IPermissionsContext): boolean {
  return context.pageType === BriefType.EXECUTION_BRIEF;
}

export function isPageTypeFlyer(context: IPermissionsContext): boolean {
  return context.pageType === "flyers";
}

function getReviewers(context: IPermissionsContext): IUser[] {
  return context.reviewers?.filter((user) => user.id === context.userId) || [];
}

export function getNumberOfReviewers(context: IPermissionsContext): number {
  return getReviewers(context).length;
}

export function isUserAlsoCreator(context: IPermissionsContext): boolean {
  return (
    Boolean(context.userId) &&
    Boolean(context.contentCreators?.map((user) => user.id).includes(context.userId!))
  );
}

export function isUserAlsoPageOwner(context: IPermissionsContext): boolean {
  return Boolean(context.pageOwnerId) && context.pageOwnerId === context.userId;
}

export function isUserAlsoParentCBOwner(context: IPermissionsContext): boolean {
  return Boolean(context.briefOwnerId) && context.briefOwnerId === context.userId;
}

export function isUserAlsoParentEBOwner(context: IPermissionsContext): boolean {
  return Boolean(context.executionOwnerId) && context.executionOwnerId === context.userId;
}

export function isUserAlsoMerchOwner(context: IPermissionsContext): boolean {
  return (
    Boolean(context.userId) &&
    Boolean(context.merchOwners) &&
    context.merchOwners.includes(context.userId!)
  );
}

export function hasUserGroup(context: IPermissionsContext, groupName: UserGroup): boolean {
  if (!context.userGroups) {
    return false;
  }

  return context.userGroups.filter((group) => group.reservedName === groupName).length > 0;
}

export function isPageTypeExecutionBriefOrWorkOrder(context: IPermissionsContext): boolean {
  return isPageTypeExecutionBrief(context) || isPageTypeWorkOrder(context);
}

export const isBrief = (context: IPermissionsContext): boolean =>
  isPageTypeCampaignBrief(context) ||
  isPageTypeExecutionBrief(context) ||
  isPageTypeWorkOrder(context);
